import { initialPlayerValues } from '../../constants'
import type {
  PlayerDetailsAdminValues,
  PlayerDetailsFormValues,
} from '../types'

export * from './adminFieldMap'
export * from './fieldOptions'
export * from './sections'

/** The admin fields, empty — before the player has loaded. */
export const initialPlayerDetailsAdminValues: PlayerDetailsAdminValues = {
  previousTeam: '',
  previousDivision: '',
  preferredPosition: '',
  skillLevel: '',
  jerseySize: '',
  shortSize: '',
  medicalConditions: '',
  previousExperience: '',
  previousYearsPlayed: '',
  howDidYouHear: '',
  teamPreference: '',
  teammateRequest: '',
  additionalComments: '',
  emailConsent: false,
  isFlagged: false,
  goalieFee: '',
  highestLevelOfPlay: '',
  isFreeAgent: false,
  isBlacklisted: false,
  blacklistComments: '',
  blacklistedAt: '',
  notes: '',
  registrationNotes: '',
}

/** Empty Player Details form, before the player has loaded. */
export const initialPlayerDetailsValues: PlayerDetailsFormValues = {
  ...initialPlayerValues,
  ...initialPlayerDetailsAdminValues,
}

/** Success copy, shared by web (toast) and mobile (bottom sheet). */
export const PLAYER_DETAILS_SUCCESS_MESSAGES = {
  update: {
    title: 'Player Updated',
    subtitle: 'The player details have been saved.',
  },
} as const
